/*
 * @Author: liumingyang
 * @Date: 2022-05-06 10:50
 * @LastEditors: mingyang_liu 18268117011@163.com
 * @LastEditTime: 2022-05-30 21:06:57
 * @Description: 异常组件封装，包括加载中，加载失败，无数据组件等
 */
import React from 'react';
import { StatusTip, ConfigProvider } from 'tea-component';
import './index.scss';
import {useIntl} from "umi";

interface AbnormalPageProps {
  status: 'normal' | 'loading' | 'empty' | 'error';
  isLoading: boolean;
  isError: boolean;
  isNoData: boolean;
  loadingMsg?: string;
  failedMsg?: string;
  nodataMsg?: string;
  component?: any;
  style?: any;
}

const Abnormal = (props: AbnormalPageProps) => {
  const {
    status = 'normal',
    // loadingMsg = "加载中...",
    // failedMsg = "未知错误",
    // nodataMsg = "当前过滤器选择下没有数据",
    style,
    ...restProps
  } = props;
  const { locale } = useIntl();

  if (status === 'normal') {
    return <>{props.children}</>;
  }
  return (
    <ConfigProvider locale={locale === "en-US" ? "en" : "zh"}>
      <StatusTip
        className="dt-action-state"
        style={{
          height: 300,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          ...style,
        }}
        status={status}
        {...restProps}
      />
    </ConfigProvider>
  );
};

export default Abnormal;
